/**
 * Given a trade rule, return the maximum and minimum price.
 * @param {object} tradeRule
 * @returns {object|null} - trade rule price range or null if invalid
 */
// eslint-disable-next-line import/prefer-default-export
export const getPriceRange = (tradeRule) => {
  // Handle null/undefined tradeRule
  if (!tradeRule || Object.keys(tradeRule).length === 0) {
    return null;
  }

  // Handle missing clauses or edges
  if (!tradeRule.clauses || !tradeRule.clauses.edges || !Array.isArray(tradeRule.clauses.edges)) {
    return null;
  }

  // Handle empty clauses array
  if (tradeRule.clauses.edges.length === 0) {
    return null;
  }

  const prices = tradeRule.clauses.edges
    .map((el) => el?.node?.price)
    .filter((price) => typeof price === 'number' && !Number.isNaN(price));

  // Handle case where no valid prices found
  if (prices.length === 0) {
    return null;
  }

  return { maximum: Math.max(...prices), minimum: Math.min(...prices) };
};
